import React, { Component } from 'react'
import EmailForm from './EmailForm'

class App extends Component {
  render() {
    return (
      <div className="App">
        <EmailForm />
      </div>
    )
  }
}

export default App



// WEBPACK FOOTER //
// ./src/components/App.js